<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="content video-monitor passflow">
        <div class="leftNav">
          <div class="leftSpot"></div>
          <div class="leftNav_title">
            客流设备列表
            <div class="title_btmLine"></div>
          </div>
          <el-input
            placeholder="搜索监控点"
            class="nav-tree-filter"
            v-model="filterText"
          ></el-input>
          <div class="nav-tree-content">
            <el-tree
              style="height: 100%"
              v-loading="loading"
              :element-loading-text="loadingText"
              @node-click="nodeClick"
              :data="nodes"
              node-key="id"
              :props="defaultProps"
              :filter-node-method="filterNode"
              class="zj-demo-player-tree-device-tree"
              ref="tree"
            ></el-tree>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="rightContent">
          <div class="topContent">
            <!-- 分屏是一个的时候开始 -->
            <div class="oneVideoBox">
              <div class="showOneVideo">
                <div style="width: 100%; height: 100%">
                  <zj-camera-preview
                    ref="childOneVideo"
                    class="videoBig-item"
                    :cameraId="cameras.cameraId"
                    :cameraName="cameras.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </div>
            </div>
            <div class="chart_data">
              <div id="chart" class="chart"></div>
            </div>
            <div class="table_data">
              <div class="zj-table-container">
                <el-table
                  :data="tableData"
                  ref="multipleTable"
                  border
                  style="width: 100%"
                  fixed
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="80"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="BeginTime"
                    label="时间"
                    :formatter="formatDate"
                  ></el-table-column>
                  <el-table-column
                    prop="LeaveNum"
                    label="出（人数）"
                  ></el-table-column>
                  <el-table-column
                    prop="EnterNum"
                    label="进（人数）"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import ZJApp from "../../../../../app";
const ZJPlayer = ZJApp.ZJPlayer;
const MediaCenter = ZJPlayer.MediaCenter;

import MyApis from "../../../apis";
export default {
  name: "PassengerflowView",
  controller: "UI",
  action: "PassengerflowView",
  components: {
    // VideoMonitorControl
  },
  data() {
    return {
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      autoplay: true,
      defaultProps: {
        children: "children",
        label: "label",
      },
      cameras: {
        cameraId: "",
        cameraName: "",
      },
      tableData: [],
      mc: "",
      treeClickCount: 0,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {},
  mounted() {
    this.submitIsShowbg(false);
    this.search();
    this.drawFlowChart();
    this.mc = new MediaCenter();
    this.mc.on("connected", () => this.onConnected());
    this.mc.on("msg", (e) => this.onRecv(e));
    this.mc.on("error", (e) => this.onError(e));
    // this.handleLoad();
    this.logInfo.ActionName = "实时客流查看";
    this.logInfo.LogMessage = "实时客流查看";
    this.logInfo.ModuleName = "客流监控";
    this.logInfo.PageName = "实时客流页面";
    this.addOperationLog();
  },
  methods: {
    ...mapActions(["submitIsShowbg"]),
    dbOneVideo() {
      // 全屏
      this.$refs.childOneVideo.onDblClick();
    },
    startOneVideo() {
      // 开始播放视频
      this.$refs.childOneVideo.play();
    },
    stopOneVideo() {
      // 停止播放视频
      this.$refs.childOneVideo.stop();
    },
    search() {
      let that = this;
      new MyApis.EquipmentApi()
        .GetRegionEquipment({
          EquipmentType: "Monitor",
          DeviceType: "SubSystem.Monitor.EquipmentType.PassengerFlow",
        })
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          this.nodes = that.convertToTreeNodesfunction(r || []);
          console.log("this.nodes");
          console.log(this.nodes);
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    getPassengerFlowList: function (deviceId) {
      let that = this;
      new MyApis.PassengerFlowApi()
        .GetPassengerFlowList({
          DeviceID: deviceId,
          BeginTime: new Date().format("yyyy-MM-dd"),
          EndTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
          ExtQueries: null,
        })
        .then((r) => {
          r = r.data.Data;
          this.tableData = r;
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    getChartData: function (deviceId) {
      let that = this;
      new MyApis.PassengerFlowApi()
        .GetChartDataEachHour({
          DeviceID: deviceId,
          BeginTime: new Date().format("yyyy-MM-dd"),
          EndTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
          ExtQueries: null,
        })
        .then((r) => {
          r = r.data.Data;
          this.drawFlowChart(r);
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          id: regionData.RegionId,
          label: regionData.RegionName,
          children: [],
        };

        if (!regionData.Devices) continue;
        for (let j = 0; j < regionData.Devices.length; j++) {
          var deviceData = regionData.Devices[j];
          region.children.push({
            id: deviceData.DeviceId,
            label: deviceData.DeviceName,
            children: [],
          });
        }
        result.push(region);
      }
      return result;
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function(data, node, self) {
      //记录点击次数
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          //把次数归零
          this.treeClickCount = 0;
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;
          //双击事件
          if (node.level == 2) {
            this.cameras.cameraId = data.id;
            this.cameras.cameraName = data.label;
            this.getPassengerFlowList(data.id);
            this.getChartData(data.id);
          }
        }
      }, 300);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onBack: function () {
      this.$emit("handlerclose");
    },
    // 成功连接到媒体中心
    onConnected() {
      console.log("链接成功");
    },
    // 接收到媒体中心的响应
    onRecv(e) {
      console.log("回应");
      console.log(e);
    },
    drawFlowChart: function (r) {
      r = r || {};
      var defaultOption = {
        title: {
          text: "客流量走势图",
          textStyle: {
            color: "#d6f0ff",
          },
          left: "10%"
        },
        grid: {
          left: "10%",
          right: "10%",
          top: "20%",
          bottom: "5%",
          containLabel: true,
        },
        tooltip: [
          {
            trigger: "axis",
            // formatter: "{b} <br />{a0}: {c0} 人<br />{a1}: {c1} 人",
          },
        ],
        series: [
          {
            name: "入",
            type: "line",
            smooth:true,
            data: r.yAxisIn || [0],
            color: ['#449d44']
          },
          {
            name: "出",
            type: "line",
            smooth:true,
            data: r.yAxisOut || [0],
            color: ['#31b0d5']
          },
        ],
        legend: [
          {
            data: ["入", "出"],
            textStyle: {
              color: "#d6f0ff",
            },
          },
        ],
        yAxis: [
          {
            name: "人数",
            type: "value",
            min :0,
            minInterval: 1,
            nameTextStyle: {
              color: "#d6f0ff",
              //fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: "#00bcfe",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#257dd4",
              },
            },
            axisLabel: {
              textStyle: {
                //fontSize: 12,
                color: "#d6f0ff",
              },
            },
          },
        ],
        xAxis: [
          {
            
            name: "时间",
            type: "category",
            boundaryGap: false,
            nameTextStyle: {
              color: "#d6f0ff",
              //fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: "#00bcfe",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#257dd4",
              },
            },
            axisLabel: {
              textStyle: {
                //fontSize: 12,
                color: "#d6f0ff",
              },
            },
            data: r.xAxis || [],
          },
        ],
      };

      var chartDom = document.getElementById("chart");
      // eslint-disable-next-line no-undef
      var myChart = echarts.getInstanceByDom(chartDom);
      if (!myChart) {
        // eslint-disable-next-line no-undef
        myChart = echarts.init(chartDom);
        myChart.setOption(defaultOption);
      }
      myChart.clear();
      myChart.setOption(defaultOption);

      window.onresize = function () {
        var chartDom = document.getElementById("chart");
        // eslint-disable-next-line no-undef
        var myChart = echarts.getInstanceByDom(chartDom);
        if (myChart) {
          myChart.resize();
        }
      };
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    }
  },
  destoryed() {
    this.submitIsShowbg(true);
  },
};
</script>

<style scoped >

.video-monitor.passflow{
  overflow: hidden !important;;
}
.leftNav {
  border: 1px solid #00bcfe;
  padding: 28px 40px;
  position: relative;
  background: #003669;
  width: 400px;
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  box-sizing: border-box;
  overflow: scroll;
}
.leftSpot {
  width: 222px;
  height: 125px;
  background: url("../../../theme-default/src/images/guangxiao.png") no-repeat;
  position: absolute;
  left: -35px;
  top: -63px;
}
.leftNav_title {
  font-size: 22px;
  font-weight: bold;
  border-bottom: 1px solid #0ec0fe;
  color: #00bcfe;
  height: 40px;
  position: relative;
}
.nav-tree-filter {
  border-radius: 6px;
  border: solid 1px #00bcfe;
  margin-top: 45px;
  margin-bottom: 20px;
}
.title_btmLine {
  width: 47px;
  height: 7px;
  background-color: #28bbff;
  position: absolute;
  bottom: -3.5px;
  left: 17px;
}
.rightContent {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.topContent {
  flex: 1;
  overflow: hidden;
  width: 100%;
}
.bottomContent {
  width: 100%;
  height: 93px;
  background-color: #003669;
  border-radius: 6px;
  border: solid 1px #91a0a5;
  margin-top: 20px;
  position: relative;
}
/* 选择一个视频 */
.oneVideoBox {
  width: 40%;
  height: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  float: left;
}
/* 左侧展示视频 */
.showOneVideo {
  flex: 1;
  height: 100%;
  background-color: black;
  border: solid 0.1rem #31cdc0;
  overflow: hidden;
}

.video-wrapper {
  width: 100%;
  height: 100%;
}

.videoBig-item {
  width: 100%;
  height: 100%;
}
.zj-demo-player-tree-device-tree .el-tree-node.is-current {
  background-color: rgba(7, 78, 133, 0.7);
}


.chart_data {
  width: 60%;
  height: 50%;
  float: left;
  overflow: hidden;
}

.chart_data .chart {
  width: 100%;
  height: 100%;
}

.table_data {
  width: 100%;
  height: 50%;
  padding-top: 1rem;
  overflow: hidden;
  float: left;
}

.table_data .zj-table-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.table_data .zj-table-container .zj-camera-player {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>